<div class="p-mb-3">
  Komentar : {{komentar ?? 'Nema'}}
</div>
